import { useSelector } from "react-redux";
import { PendingPermissionKeys } from "utilities/permissionConst";

const usePermissions = ({ permissionKey }) => {
  const permission = useSelector((s) => s?.profileData);
  const role = useSelector((s) => s?.login?.role);

  let permissionObject = { isView: false, isAdd: false, isDelete: false };

  if (role == "1") {
    // super admin
    return (permissionObject = {
      ...permissionObject,
      ...{ isView: true, isAdd: true, isDelete: true },
    });
  }

  if (PendingPermissionKeys.includes(permissionKey)) {
    const canView =
      permission.pendingRequestSubViewNames.includes(permissionKey);
    const canAdd = permission.pendingRequestSubAddNames.includes(permissionKey);
    const canDelete =
      permission.pendingRequestSubDeletNames.includes(permissionKey);
    return {
      ...permissionObject,
      ...{ isView: canView, isAdd: canAdd, isDelete: canDelete },
    };
  }

  if (permission[permissionKey]) {
    return {
      ...permissionObject,
      ...{
        isView: permission[permissionKey]?.isView,
        isAdd: permission[permissionKey]?.isAdd,
        isDelete: permission[permissionKey]?.isDelete,
      },
    };
  }

  return permissionObject;
};

export default usePermissions;
